import { Box, Typography, Link } from '@mui/material';
import { PropTypes } from 'prop-types';
import { Fragment } from 'react';

ThematicSection.propTypes = {
  items: PropTypes.array,
};

export default function ThematicSection({ items }) {
  return (
    items?.length > 0 && (
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1,
          mb: 2,
        }}
      >
        {items.map((item, idx) => (
          <Fragment key={idx}>
            <Link
              variant="h6"
              to={'#'}
              key={item.title + idx}
              href={`/clanky?filter=%7B"categoryKeys"%3A%5B"${item.categoryKey}"%5D%7D&page=1`}
              sx={{
                mt: -0.2,
                fontWeight: '400 !important',
                color: '#F0F0F9',
                textDecoration: 'underline',
                textUnderlinePosition: 'under',
                '&:hover': {
                  // scale: '1.03',
                  textDecoration: 'underline !important',
                  textUnderlinePosition: 'under',
                },
              }}
            >
              {item.name}
            </Link>
            <Typography variant="h6" sx={{ ml: -0.8 }}>
              {item !== items[items?.length - 1] ? ', ' : ''}
            </Typography>
          </Fragment>
        ))}
      </Box>
    )
  );
}
